import React from 'react';

interface WifiConnectionOffIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
}

/**
 * Wifi connection off icon — a wifi signal struck through with a diagonal line.
 *
 * Shown on the offline connection bar (Figma node 16924:258073). Stroke colour
 * defaults to `currentColor`, so the parent's text colour drives the tint, and can
 * be overridden via `color`; `size` defaults to 22.4 to match the Figma artwork.
 * @param props - Standard icon props: `size`, `color` and any SVG attribute.
 * @returns The wifi-off icon SVG.
 */
const WifiConnectionOffIcon = ({
  size = 22.4,
  color = 'currentColor',
  ...restProps
}: WifiConnectionOffIconProps): React.ReactElement => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22.4 22.4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...restProps}
    >
      <path
        d="M0.933333 0.933333L21.4667 21.4667M15.6053 10.3227C16.3698 10.6958 17.0847 11.1629 17.7333 11.7133M4.66667 11.7133C6.04994 10.5568 7.71481 9.78713 9.492 9.48267M9.996 4.71333C11.9956 4.55221 14.0071 4.79562 15.9106 5.42903C17.814 6.06244 19.5703 7.07287 21.0747 8.4M1.32533 8.4C2.62002 7.25559 4.10452 6.34594 5.712 5.712M7.96133 15.036C8.90886 14.3628 10.0424 14.0012 11.2047 14.0012C12.367 14.0012 13.5005 14.3628 14.448 15.036M11.2 18.6667H11.2093"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default React.memo(WifiConnectionOffIcon);
